<div class="prescription-dialog" dir="rtl">

  <!-- Header -->
  <div class="prescription-header">
    <h2 class="t-title-main">מרשם רפואי</h2>
    <button class="close-btn" (click)="close()" matTooltip="סגור">
      <img src="assets/icons/x.svg" alt="סגור" onerror="style.display='none'" />
      <span class="close-x" aria-hidden="true">✕</span>
    </button>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="loading-bar">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>

  <!-- Patient Details -->
  <div class="patient-strip">
    <div class="patient-field"><span class="patient-label">שם המטופל/ת</span><span class="patient-val">{{ data.patientName }}</span></div>
    <div class="patient-field"><span class="patient-label">ת.ז.</span><span class="patient-val">{{ data.patientID }}</span></div>
    <div class="patient-field"><span class="patient-label">תאריך לידה</span><span class="patient-val">{{ data.patientDOB | date:'dd/MM/yyyy' }}</span></div>
    <div class="patient-field" *ngIf="data.HMO"><span class="patient-label">קופה</span><span class="patient-val">{{ getHMO(data.HMO) }}</span></div>
    <div class="patient-field" *ngIf="createdAt"><span class="patient-label">תאריך יצירת המרשם</span><span class="patient-val">{{ createdAt | date:'dd/MM/yyyy' }}</span></div>
  </div>

  <!-- Drug Search Row -->
  <div class="drug-search-wrap">
  <div class="drug-search-row" *ngIf="status !== 'signed'">

    <div class="t-field field-wrap drug-field">
      <label class="field-label">חיפוש תרופה</label>
      <i class="t-sep"></i>
      <input class="t-input" [formControl]="drugSearchCtrl" placeholder="הקלד שם תרופה..." autocomplete="off" />
    </div>

    <div class="t-field field-wrap dosage-field">
      <label class="field-label">מינון</label>
      <i class="t-sep"></i>
      <input class="t-input" [formControl]="dosageCtrl" placeholder="לדוג׳ 500" />
    </div>

    <div class="t-field field-wrap unit-field">
      <label class="field-label">יחידה</label>
      <i class="t-sep"></i>
      <select class="t-input t-select" [formControl]="unitCtrl">
        <option value="">בחר...</option>
        <option *ngFor="let u of units" [value]="u.code">{{ u.he }}</option>
      </select>
    </div>

    <div class="t-field field-wrap route-field">
      <label class="field-label">דרך מתן</label>
      <i class="t-sep"></i>
      <select class="t-input t-select" [formControl]="routeCtrl">
        <option value="">בחר...</option>
        <option *ngFor="let r of routes" [value]="r.code">{{ r.he }}</option>
      </select>
    </div>

    <div class="t-field field-wrap timing-field">
      <label class="field-label">אופן מתן</label>
      <i class="t-sep"></i>
      <select class="t-input t-select" [formControl]="timingCtrl">
        <option value="">בחר...</option>
        <option *ngFor="let t of timings" [value]="t.code">{{ t.he }}</option>
      </select>
    </div>

    <div class="t-field field-wrap frequency-field">
      <label class="field-label">תדירות</label>
      <i class="t-sep"></i>
      <select class="t-input t-select" [formControl]="frequencyCtrl">
        <option value="">בחר...</option>
        <option *ngFor="let f of frequencies" [value]="f.code">{{ f.he }}</option>
        <option [value]="frequencyOther">אחר (הקלד)</option>
      </select>
    </div>

    <div class="t-field field-wrap frequency-custom-field" *ngIf="frequencyCtrl.value === frequencyOther">
      <label class="field-label">תדירות (חופשי)</label>
      <i class="t-sep"></i>
      <input class="t-input" [formControl]="frequencyCustomCtrl" placeholder="לדוג׳ כל 5 שעות" />
    </div>

    <div class="t-field field-wrap intervalvalue-field">
      <label class="field-label">משך</label>
      <i class="t-sep"></i>
      <input class="t-input" type="number" min="1" [formControl]="intervalValueCtrl" placeholder="מס׳" />
    </div>

    <div class="t-field field-wrap intervalunit-field">
      <label class="field-label">יחידת זמן</label>
      <i class="t-sep"></i>
      <select class="t-input t-select" [formControl]="intervalUnitCtrl">
        <option *ngFor="let iu of intervalUnits" [value]="iu.code">{{ iu.he }}</option>
      </select>
    </div>

    <div class="t-field field-wrap instructions-field">
      <label class="field-label">הוראות</label>
      <i class="t-sep"></i>
      <input class="t-input" [formControl]="instructionsCtrl" placeholder="אופציונלי" />
    </div>

    <button class="btn-add"
      (click)="addItem()"
      [disabled]="!selectedDrug || saving">
      + הוסף
    </button>

  </div>

  <!-- Drug Autocomplete Dropdown -->
  <div class="drug-dropdown" *ngIf="filteredDrugs.length > 0" >
    <div class="drug-option" *ngFor="let drug of filteredDrugs" (click)="selectDrug(drug)">
      <span class="drug-name-he">{{ drug.name }}</span>
      <span class="drug-name-en">{{ drug.nameEn }}</span>
      <span class="drug-active" *ngIf="drug.activeIngredient">· {{ drug.activeIngredient }}</span>
    </div>
  </div>

  <!-- Manual add: allow adding a typed drug that isn't in the list -->
  <div class="drug-manual"
       *ngIf="status !== 'signed' && !selectedDrug && filteredDrugs.length === 0 && (drugSearchCtrl.value || '').length >= 2">
    <span>התרופה לא נמצאה?</span>
    <button type="button" class="btn-manual" (click)="addManualDrug()">הוסף ידנית "{{ drugSearchCtrl.value }}"</button>
  </div>

  </div><!-- end drug-search-wrap -->

  <!-- Error -->
  <div class="error-msg" *ngIf="errorMsg">{{ errorMsg }}</div>

  <!-- Prescription Table -->
  <table mat-table [dataSource]="items" class="prescription-table" *ngIf="items.length > 0">

    <ng-container matColumnDef="drugName">
      <th mat-header-cell *matHeaderCellDef>תרופה</th>
      <td mat-cell *matCellDef="let item">{{ item.DrugName }}</td>
    </ng-container>

    <ng-container matColumnDef="dosage">
      <th mat-header-cell *matHeaderCellDef>מינון</th>
      <td mat-cell *matCellDef="let item">{{ item.Dosage }}</td>
    </ng-container>

    <ng-container matColumnDef="unit">
      <th mat-header-cell *matHeaderCellDef>יחידה</th>
      <td mat-cell *matCellDef="let item">{{ unitLabel(item.Unit) }}</td>
    </ng-container>

    <ng-container matColumnDef="route">
      <th mat-header-cell *matHeaderCellDef>דרך מתן</th>
      <td mat-cell *matCellDef="let item">{{ routeLabel(item.Route) }}</td>
    </ng-container>

    <ng-container matColumnDef="timing">
      <th mat-header-cell *matHeaderCellDef>אופן מתן</th>
      <td mat-cell *matCellDef="let item">{{ timingLabel(item.TimingCode) }}</td>
    </ng-container>

    <ng-container matColumnDef="frequency">
      <th mat-header-cell *matHeaderCellDef>תדירות</th>
      <td mat-cell *matCellDef="let item">{{ frequencyLabel(item) }}</td>
    </ng-container>

    <ng-container matColumnDef="intervalValue">
      <th mat-header-cell *matHeaderCellDef>משך</th>
      <td mat-cell *matCellDef="let item">{{ item.IntervalValue }}</td>
    </ng-container>

    <ng-container matColumnDef="intervalUnit">
      <th mat-header-cell *matHeaderCellDef>יחידת זמן</th>
      <td mat-cell *matCellDef="let item">
        <span *ngIf="item.IntervalValue">{{ intervalUnitLabel(item.IntervalUnit) }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="instructions">
      <th mat-header-cell *matHeaderCellDef>הוראות</th>
      <td mat-cell *matCellDef="let item">{{ item.Instructions }}</td>
    </ng-container>

    <ng-container matColumnDef="remove">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item">
        <button class="btn-remove" (click)="removeItem(item)"
          *ngIf="status !== 'signed'" matTooltip="הסר תרופה">✕</button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
  </table>

  <div class="empty-table" *ngIf="items.length === 0 && !loading">
    אין תרופות במרשם  חפש תרופה למעלה והוסף
  </div>

  <!-- Narcotic prescription toggle -->
  <div class="narcotic-section">
    <div class="narcotic-toggle-row">
      <span class="narcotic-label" [class.active]="!isNarcotic">מרשם רגיל</span>
      <button type="button" class="toggle-switch" [class.on]="isNarcotic"
        (click)="toggleNarcotic()"
        [disabled]="status === 'signed' || status === 'printed'"
        role="switch" [attr.aria-checked]="isNarcotic" aria-label="מרשם נרקוטי">
        <span class="toggle-knob"></span>
      </button>
      <span class="narcotic-label" [class.active]="isNarcotic">מרשם נרקוטי</span>
    </div>

    <div class="narcotic-fields" *ngIf="isNarcotic">
      <div class="t-field field-wrap doctorid-field">
        <label class="field-label">ת"ז רופא <span class="req">*</span></label>
        <i class="t-sep"></i>
        <input class="t-input" [formControl]="doctorIdCtrl" placeholder="חובה במרשם נרקוטי"
          [readonly]="doctorIdOnFile || status === 'signed' || status === 'printed'" />
      </div>
      <div class="doctorid-hint" *ngIf="doctorIdOnFile">מולא אוטומטית מפרופיל המשתמש</div>
      <div class="t-field field-wrap narcotic-instructions-field">
        <label class="field-label">הוראות <span class="req">*</span></label>
        <i class="t-sep"></i>
        <textarea class="t-input narcotic-textarea" rows="3" [formControl]="narcoticInstructionsCtrl"
          placeholder="כתוב את הוראות התרופה במלל רציף"
          [readonly]="status === 'signed' || status === 'printed'"></textarea>
      </div>
    </div>
  </div>

  <!-- Actions -->
  <div class="action-row">

    <ng-container>
      <button class="btn-primary"
        (click)="sign()"
        [disabled]="items.length === 0 || signing || !narcoticValid"
        *ngIf="status !== 'signed' && status !== 'printed'">
        {{ signing ? 'חותם...' : 'חתום ושמור' }}
      </button>

      <span class="signed-info" *ngIf="status === 'signed' || status === 'printed'">
        נחתם ע"י {{ signerTitle ? signerTitle + ' ' : '' }}{{ signerName }} ב-{{ signedAt | date:'dd/MM/yyyy' }}
      </span>

      <button class="btn-print-icon" (click)="openPrint()"
        *ngIf="status === 'signed' || status === 'printed'"
        matTooltip="הדפס מרשם">
        <img src="assets/icons/print.svg" alt="הדפס" style="height:1.4em;" onerror="style.display='none'" />
        <span>הדפס</span>
      </button>
    </ng-container>

    <span class="action-spacer"></span>
    <button class="btn-cancel" (click)="close()">סגור</button>
  </div>

</div>
